import { render, staticRenderFns } from "./DocumentoCard.vue?vue&type=template&id=0f2af35c&"
import script from "./DocumentoCard.vue?vue&type=script&lang=js&"
export * from "./DocumentoCard.vue?vue&type=script&lang=js&"
import style0 from "./DocumentoCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports